import { BillingStrategy, PurchaseStatus } from '@galaxy/billing';

export function purchaseStatusToDisplayString(s: PurchaseStatus): string {
  switch (s) {
    case PurchaseStatus.Pending:
      return 'Pending';
    case PurchaseStatus.Due:
      return 'Due';
    case PurchaseStatus.Dunning:
      return 'Overdue';
    case PurchaseStatus.Failed:
      return 'Failed';
    case PurchaseStatus.Success:
      return 'Succeeded';
    default:
      return '';
  }
}

export function billingStrategyToDisplayString(strategy: BillingStrategy): string {
  switch (strategy) {
    case BillingStrategy.EndOfPeriod:
      return 'Postpay';
    case BillingStrategy.StartOfPeriod:
      return 'Prepay';
    case BillingStrategy.Instantly:
      return 'Instant';
    case BillingStrategy.EndOfDay:
      return 'End of Day';
    default:
      return 'Unknown';
  }
}
